// src/i18n.js

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importer les fichiers de traduction
import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';

// Configuration des ressources de traduction
const resources = {
  fr: {
    translation: translationFR,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  .use(LanguageDetector) // Détecter la langue de l'utilisateur
  .use(initReactI18next) // Passer l'instance i18n à react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Langue de repli si la langue détectée n'est pas disponible
    debug: false, // Mettre à true pour voir les logs de débogage

    interpolation: {
      escapeValue: false, // React se charge de l'échappement
    },
  });

export default i18n;